<template>
  <div class="container-fluid py-4">
    <div class="row mt-4">
      <div class="col-12">        
        <chat :messages="messagesList"></chat>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Chat from "./components/Chat.vue";
import { mapMutations, mapActions, mapState,mapGetters } from "vuex";

export default {
  name: "MessageDetail",
  components: {
    Chat,
  },
  data() {
    return {
      messagesList: [],
    };
  },
  methods: {
    ...mapMutations(["SET_NOTIFICATION_MARK_AS_VIEWED"]),
    async getMessages(idMessage) {
      this.$store.commit('setLoading',true);
      try {
        const { status, data } = await axios.get(
          `${process.env.VUE_APP_API_BOOKAPP}messages/chat/${idMessage}`,
          {
            headers: {
              Authorization: localStorage.getItem("token_bookapp"),
              conexion: localStorage.getItem("conexion"),
            },
          }
        );

        if (status == 200) {
          this.messagesList = data;
        
          this.messagesList.map((m) => {
            m = { ...m.message };
          });  
          this.SET_NOTIFICATION_MARK_AS_VIEWED(idMessage);
        } else {
          console.log("Hubo un error coonsultando el detalle del mensaje");
        }
      } catch (error) {
        console.log("Hubo un error coonsultando el detalle del mensaje");
      }finally{
        this.$store.commit('setLoading',false);
      } 
    },
  },
  watch: {
    '$route.params': {
      handler(newParams, oldParams) {
        this.getMessages(newParams.ideMensaje); 
      },
      immediate: true, 
      deep: true, 
    },
  },
  mounted() {
    this.getMessages(this.$route.params.idMensaje);
  },
};
</script>
